module.exports = __webpack_public_path__ + "static/media/good-review1.a65254db.png";